import React from 'react';

import { Flex, Paragraph } from '@rover/kibble/core';
import { SpacingSystemType } from '@rover/kibble/core/styledSystemPropTypes';

const SubmissionError = ({
  marginTop,
  message,
}: {
  marginTop?: SpacingSystemType;
  message?: string;
}): JSX.Element => {
  return (
    <Paragraph textColor="error" role="alert" marginTop={marginTop}>
      {/* (DEV-104195): Translate */}
      <Flex webAs="span" justifyContent="center">
        {message ?? 'Something went wrong. Please try again later.'}
      </Flex>
    </Paragraph>
  );
};

export default SubmissionError;
